import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BrandCarousel from './BrandCarousel';
import useStyles from '../useStyles';
const Results = () => {
    const { classes } = useStyles();
    return (_jsxs("section", { className: classes.container, children: [_jsxs("div", { className: classes.sectionHeader, children: [_jsx("h1", { className: classes.sectionHeading, children: "We help brands get results" }), _jsx("p", { className: classes.sectionSubHeading, children: "We're a marketing platform and agency that helps you build tailored campaigns, not an advertising placement service" })] }), _jsx(BrandCarousel, { "data-testid": "results-brand-carousel" })] }));
};
export default Results;
